import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

(function ($) {
  function counters() {
    gsap.registerPlugin(ScrollTrigger);
    ScrollTrigger.defaults({
      toggleActions: 'restart none none none',
    });

    gsap.utils.toArray('.ct_counter').forEach(counter => {
      const startValue = counter.getAttribute('data-counter-start') || 0;
      const endValue = counter.getAttribute('data-counter-end');
      const duration = counter.getAttribute('data-counter-duration') || 3;
      const countElement = counter.querySelector('.count-number');
      const counting = {val: startValue};

      gsap.to(counting, {
        scrollTrigger: {
          trigger: counter,
          start: 'top bottom-=50px',
        },
        val: endValue,
        duration: duration,
        onUpdate: () => {
          const number = gsap.utils.snap(1, counting.val);
          countElement.innerHTML = number;
        }
      })
    });
  }

  $(document).ready(function() {
    counters();
  })
}(jQuery));
